<script lang="ts">
    import CardLayout from "$items/CardLayout.svelte";
    import SalesCard from "$lib/partials/sales/SalesCard.svelte";
    import {Badge, Heading} from "flowbite-svelte";
    import {formatCurrency} from "$lib/utils/currency";
    import dayjs from "dayjs";

    let rdsPrice: number = 35.91
    let shkPrice: number = 33.11

    interface Card {
        name: string;
        tagline:string;
        cardIcon: string;
        options: { value: string, percentage: number }[];
        selected: boolean;
        valueSelected: string;
    }


    let selectedCards: Card[] = [
        {
            name: "Jahresumsatz",
            cardIcon: "Jahresumsatz",
            tagline: "Erlöse im gesamten Kalenderjahr",
            options: [
                {
                    value: "50.000 | 3,0%",
                    percentage: 3
                },
                {
                    value: "100.000 | 4,0%",
                    percentage: 4
                },
                {
                    value: "250.000 | 5,0%",
                    percentage: 5
                },
                {
                    value: "500.000 | 6,0%",
                    percentage: 6
                },
                {
                    value: "999.000 | 7,0%",
                    percentage: 7
                },
            ],
            selected: false,
            valueSelected: "",
        },
        {
            name: "Garantie",
            cardIcon: "Garantie",
            tagline: "Schichtgarantie die Woche",
            options: [
                {
                    value: "1d*5 pax / weekly / 44w | 1,0%",
                    percentage: 1
                },
                {
                    value: "2d*5 pax / weekly / 44w | 2,0%",
                    percentage: 2
                },
                {
                    value: "3d*5 pax / weekly / 44w | 3,0%",
                    percentage: 3
                },
                {
                    value: "4d*5 pax / weekly / 44w | 4,0%",
                    percentage: 4
                },
                {
                    value: "5d*5 pax / weekly / 44w | 7,0%",
                    percentage: 7
                },
            ],
            selected: false,
            valueSelected: "",
        },
        {
            name: "Volumen",
            tagline: "Veranstaltungsvolumen im Jahr",
            cardIcon: "Volumen",
            options: [
                {
                    value: "6 VA p.a > 5.000 &euro; | 3,0%",
                    percentage: 3
                },
                {
                    value: "12 VA p.a > 5.000 &euro; | 4,0%",
                    percentage: 4
                },
                {
                    value: "18 VA p.a > 5.000 &euro; | 5,0%",
                    percentage: 5
                },
                {
                    value: "24 VA p.a > 5.000 &euro; | 6,0%",
                    percentage: 6
                },
                {
                    value: "36 VA p.a > 5.000 &euro; | 7,0%",
                    percentage: 7
                },
            ],
            selected: false,
            valueSelected: "",
        },
        {
            name: "Exklusivität",
            tagline: "exklusive Rahmenvereinbarung",
            cardIcon: "Exklusivität",
            options: [
                {
                    value: "7,0%",
                    percentage: 7
                },
            ],
            selected: false,
            valueSelected: "",
        },
    ];




    $: total = selectedCards.reduce((acc:number, card: Card) => {
        if (card.selected) {
            const index = card.options.findIndex(x => x.value === card.valueSelected )
            return acc + card.options[index].percentage;
        }
        return acc;
    }, 0) || 0

    const handleSelectCards = (
        name: string,
        event: { detail: { value: string } },
    ) => {
        const { value } = event.detail;

        selectedCards = selectedCards.map((card) => {
            if (card.name === name) {
                return {
                    ...card,
                    selected: !card.selected,
                    valueSelected: !card.selected ? value : "",
                };
            }
            return card;
        });

        // Ensure only two cards can be selected at the same time
        if (selectedCards.filter((card) => card.selected).length > 2) {
            selectedCards = selectedCards.map((card) => ({
                ...card,
                selected: card.name === name,
                valueSelected: card.name === name ? value : "",
            }));
        }
    };
</script>

<CardLayout
    title="recrew Sonderkonditionen {dayjs().year()}"
    className="flex flex-col"
>
    <div class="w-4/5 mx-auto">
        <Heading tag="h3" class="text-neutral-600">Preis- und Leistungsübersicht {dayjs().year()}</Heading>

        <span class="text-lg">Unit Service München</span>
        <div class="flex flex-row flex-1 justify-between gap-3 mt-6 text-xl mb-5">
            <span><span class="text-slate-400">*re</span>crew Überlassung von</span>
            <span>Preis</span>
        </div>

        <div class="flex flex-col my-4">
            <div class="flex flex-row flex-1 justify-between font-extrabold">
                <span>Veranstaltungsleiter (VAL) *5</span>
                <span>á 53,54 € Std.</span>
            </div>
            <ul class="list-disc">
                <li class="ml-8">
                    fachgeschult / mit Top Referenzen für Restaurant, Catering &
                    Event
                </li>
                <li class="ml-8">
                    führt VA eigenverantwortlich durch & weist alle Gewerke an
                </li>
                <li class="ml-8">recrew outfit VAL: Anzug 3-teilig schwarz,</li>
            </ul>
            <span class="ml-8">
                Hemd/Bluse weiß, Krawatte schwarz, Schuhe schwarz
            </span>
        </div>
        <div class="flex flex-col my-4 ">
            <div class="flex flex-row flex-1 justify-between font-extrabold">
                <span>Oberkellner (OKE) *4</span>
                <span>á 49,87 € Std.</span>
            </div>
            <ul class="list-disc">
                <li class="ml-8">
                    geschult mit Referenzen | >3 Jahre Berufserfahrung
                </li>
                <li class="ml-8">
                    verantwortet alle Stationen | koordiniert / weist CDS/CDB
                    (Küche) an
                </li>
                <li class="ml-8">recrew outfit OKE: Anzug 2-teilig schwarz,</li>
            </ul>
            <span class="ml-8">
                Hemd/Bluse weiß, Krawatte schwarz, Schuhe schwarz
            </span>
        </div>
        <div class="flex flex-col my-4">
            <div class="flex flex-row flex-1 justify-between font-extrabold">
                <span>Chef de Service (CDS) oder Demi de Bar (DDB) *3</span>
                <span>á 41,66 € Std.</span>
            </div>
            <ul class="list-disc">
                <li class="ml-8">
                    versiert / geschult | 1 Jahre Berufserfahrung >30 Events
                </li>
                <li class="ml-8">
                    verantwortet eigene Station | koordiniert / weist SHK/RDS an
                </li>
                <li class="ml-8">
                    recrew outfit CDS/DDB: Hemd/Bluse weiß, Schuhe schwarz
                </li>
            </ul>
            <span class="ml-8">Hose schwarz, Schuhe schwarz</span>
        </div>
        <div class="flex flex-col my-4">
            <div class="flex flex-row flex-1 justify-between font-extrabold">
                <span>Recrew Demi Service (RDS) *2</span>
                <span>á {formatCurrency(rdsPrice, 'EUR') } Std.</span>
            </div>
            <ul class="list-disc">
                <li class="ml-8">
                    versiert / geschult | >3 Monate recrew mit Erfahrung >20
                    Events
                </li>
                <li class="ml-8">
                    koordiniert Menü und Getränkeservice / weist Teams bis 4
                    SHK. an
                </li>
                <li class="ml-8">
                    recrew outfit RDS: Hemd/Bluse weiß, Hose schwarz, Schuhe
                    schwarz
                </li>
            </ul>
            <span class="ml-8">Hose schwarz, Schuhe schwarz</span>
        </div>
        <div class="flex flex-col my-4">
            <div class="flex flex-row flex-1 justify-between font-extrabold">
                <span>Servicehilfskraft (SHK) *1</span>
                <span>á {formatCurrency(shkPrice, 'EUR')} Std.</span>
            </div>
            <ul class="list-disc">
                <li class="ml-8">Einsteiger | geschult und geübt</li>
                <li class="ml-8">geübt in Getränke- & Menüservice</li>
                <li class="ml-8">
                    recrew outfit SHK: Hemd/Bluse weiß, Hose schwarz, Schuhe
                    schwarz
                </li>
            </ul>
            <span class="ml-8">Hose schwarz, Schuhe schwarz</span>
        </div>
        <p class="mb-4 mt-5">
            Abgerechnet werden die tatsächlich geleisteten Stunden im
            Viertelstunden-Takt. Es gilt eine Mindesteinsatzzeit von 6 Stunden
            pro Einsatz.
        </p>
    </div>
    <div class="grid grid-cols-4 gap-5 w-4/5 mx-auto py-6">
        {#each selectedCards as card}
            <SalesCard

                bind:card
                on:cardSelected={(e) => handleSelectCards(card.name, e)}
            />
        {/each}
    </div>
    <!--<div class="flex flex-row justify-end items-center gap-7 w-9/12 mx-auto py-6 font-extrabold">
        {#each selectedCards.filter((card) => card.selected) as card}
            <Badge color="primary" class="w-fit">{card.name} | {card.valueSelected}</Badge>
        {/each}
        <p>= Total: {(total * 100).toFixed(1)} %</p>
    </div>-->
    <div  class="w-4/5 mx-auto">
        <div class="flex flex-row flex-1 justify-between gap-3 mt-3 text-xl mb-5">
            <span>Discount Übersicht</span>
            <span>%</span>
        </div>
        {#each selectedCards.filter((card) => card.selected) as card}
            <div class="flex flex-col my-4 rounded">
                <div class="flex flex-row flex-1 justify-between ">
                    <span> {card.name} {@html card.valueSelected}</span>
                    <span>{card.valueSelected.split('|')[1] || card.valueSelected} </span>
                </div>

            </div>
        {/each}
        <div class="flex flex-col my-4 rounded">
            <div class="flex flex-row flex-1 justify-between ">
                <span>Gesamtdiscount</span>
                <span class="font-semibold text-primary-600">{total}% </span>
            </div>
        </div>
    </div>
    <div  class="w-4/5 mx-auto">
        <div class="flex flex-row flex-1 justify-between gap-3 mt-3 text-xl mb-5">
            <span><span class="text-slate-400">*re</span>crew Überlassung von</span>
            <span>Preis</span>
        </div>
        <div class="flex flex-col my-4 rounded">
            <div class="flex flex-row flex-1 justify-between ">
                <span>Recrew Demi Service (RDS) *2</span>
                <span>á {formatCurrency(rdsPrice, 'EUR')} Std.</span>
            </div>
            <p class="w-full text-right text-primary-600 font-extrabold">*DISCOUNT {formatCurrency(rdsPrice * (100-total)/100, 'EUR')} Std.</p>

        </div>
        <div class="flex flex-col my-4">
            <div class="flex flex-row flex-1 justify-between">
                <span>Servicehilfskraft (SHK) *1</span>
                <span>á {formatCurrency(shkPrice, 'EUR')} Std.</span>
            </div>
            <p class="w-full text-right font-extrabold text-primary-600">*DISCOUNT {formatCurrency(shkPrice * (100-total)/100, 'EUR')} Std.</p>

        </div>
    </div>


    <div class="w-4/5 mx-auto pt-6">

        <h3 class="text-neutral-600 text-xl">
            Zuschläge Nacht, Sonn- und Feiertage
        </h3>

        <p class="my-2">
            Für Einsätze zwischen 22:00 und 06:00 wird für alle in diesem Zeitraum geleisteten Stunden ein Aufschlag von 10% auf den jeweiligen Stundenpreis erhoben. 
        </p>

        <p class="my-2">
            Für Einsätze an Sonntagen wird, für alle an diesen Tagen geleisteten Stunden, ein Aufschlag von 20% auf den jeweiligen Stundenpreis erhoben. 
        </p>

        <p class="my-2">
            Für Einsätze an Feiertagen wird, für alle an diesen Tagen geleisteten Stunden, ein Aufschlag von 50% auf den jeweiligen Stundenpreis erhoben. 	
        </p>

        <h5 class="text-neutral-600 text-xl">
            Alle Preise verstehen sich zzgl. 19 % USt.
        </h5>
    </div>

</CardLayout>
